import { createRouter, createWebHistory } from 'vue-router'
import Layout from "@/components/layout";
import store from '@/store'

// 基础路由（所有用户都可以访问）
const constantRoutes = [
  {
    path: "/",
    // redirect: "/dashboard/index",  // 静态重定向到dashboard页面
    component: Layout,
  },
  {
    path: "/login",
    hidden: true,
    component: () => import("@/views/login/index")
  },
  {
    path: "/auth-redirect",
    hidden: true,
    component: () => import("@/views/login/auth-redirect")
  },
  {
    path: "/dashboard",
    component: Layout,
    meta: { title: 'Dashboard', roles: ['admin', 'agent', 'customer'] },
    children: [
      {
        name: "Dashboard Admin",
        path: "admin",
        meta: { 
          title: "Dashboard(Admin)", 
          roles: ['admin'] 
        },        
        component: () => import("@/views/dashboard/admin"),
      },
      {
        name: "Dashboard Agent",
        path: "agent",
        meta: { 
          title: "Dashboard(Agent)", 
          roles: ['agent'] 
        },        
        component: () => import("@/views/dashboard/agent"),
      },
      {
        name: "Dashboard Customer",
        path: "customer",
        meta: { 
          title: "Dashboard(Customer)", 
          roles: ['customer']
        },        
        component: () => import("@/views/dashboard/customer"),
      },            
    ]
  },
  // {
  //   path: "/404",
  //   hidden: true,
  //   component: () => import("@/views/error-page/404")
  // },
  // {
  //   path: "/:pathMatch(.*)*",
  //   redirect: "/404",
  //   hidden: true
  // }
]

// 异步路由（需要权限控制）
const asyncRoutes = [
  {
    path: "/agent",
    icon: "agent",
    redirect: "/agent/list",
    component: Layout,
    meta: { roles: ['admin', 'agent'] },
    children: [
      {
        name: "Agent List",
        path: "list",
        meta: { 
          title: "Agent(List)", 
          roles: ['admin'] 
        },
        component: () => import("@/views/agent/list"),
      },
      {
        name: "Agent Detail",
        path: "detail/:agentId(\\d+)",
        meta: { 
          title: "Agent(Detail)", 
          activeMenu: "/agent/list", 
          noCache: true,
          roles: ['admin', 'agent'] 
        },
        hidden: true,
        component: () => import("@/views/agent/detail"),
      },
      // {
      //   name: "Agent Service",
      //   path: "service",
      //   meta: { 
      //     title: "Agent(Service)", 
      //     roles: ['agent'] 
      //   },
      //   hidden: true,
      //   component: () => import("@/views/agent/service"),
      // },
    ]
  },
  {
    path: "/customer",
    icon: "customer",
    redirect: "/customer/list",
    component: Layout,
    meta: { roles: ['admin', 'agent', 'customer'] },
    children: [
      {
        name: "Customer List",
        path: "list",
        meta: { 
          title: "Customer(List)", 
          roles: ['admin', 'agent'] 
        },
        component: () => import("@/views/customer/list"),
      },
      {
        name: "Customer Detail",
        path: "detail/:customerId(\\d+)",
        meta: { 
          title: "Customer(Detail)", 
          activeMenu: "/customer/list", 
          noCache: true,
          roles: ['admin', 'agent', 'customer'] 
        },
        hidden: true,
        component: () => import("@/views/customer/detail"),
      },
      // {
      //   name: "Customer Service",
      //   path: "service/:customerId(\\d+)/:agentId(\\d+)?",
      //   meta: { 
      //     title: "Customer(Service)", 
      //     roles: ['customer'] 
      //   },
      //   hidden: true,
      //   component: () => import("@/views/customer/service"),
      // },      
    ]
  },  
  {
    path: "/device",
    icon: "device",
    redirect: "/device/list",
    component: Layout,
    meta: { roles: ['admin', 'agent', 'customer'] },
    children: [
      {
        name: "Device List",
        path: "list",
        meta: { 
          title: "Device(List)", 
          roles: ['admin', 'agent', 'customer'] 
        },
        component: () => import("@/views/device/list"),
      },      
      {
        name: "Device Detail",
        path: "detail/:deviceId(\\d+)",
        meta: { 
          title: "Device(Detail)", 
          activeMenu: "/device/list", 
          noCache: true,
          roles: ['admin', 'agent', 'customer'] 
        },
        hidden: true,
        component: () => import("@/views/device/detail"),
      },
    ]
  },
]

// 创建路由实例
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: constantRoutes
})

// 重置路由的方法
router.resetRouter = function() {
  const newRouter = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes: constantRoutes
  })
  this.matcher = newRouter.matcher
}

// 动态添加路由的方法
router.addRoutes = function(routes) {
  routes.forEach(route => {
    this.addRoute(route)
  })
}

export { constantRoutes, asyncRoutes }
export default router